export const BATCH_TYPE_LABELS: Record<string, string> = {
  advance: 'Аванс по зарплате',
  final_salary: 'Окончательный расчет',
  shift_allowance: 'Вахтовая надбавка',
  vacation: 'Отпускные',
  dismissal: 'Расчет при увольнении',
  bonus: 'Премиальный фонд',
};

export const BATCH_STATUS_CONFIG: Record<
  string,
  { label: string; tone: 'success' | 'warning' | 'info' | 'neutral' }
> = {
  verified_chronum: { label: 'Сверено Хронум', tone: 'info' },
  in_payment_queue: { label: 'В очереди платежей', tone: 'warning' },
  on_ceo_approval: { label: 'На акцепте у Гендиректора', tone: 'warning' },
  approved: { label: 'Акцептовано', tone: 'success' },
  paid: { label: 'Выплачено', tone: 'success' },
};
